import { StaticImage } from 'gatsby-plugin-image';
import React from 'react';
import BeatingHeart from '../BeatingHeart';

function Github() {
  return (
    <BeatingHeart>
      <StaticImage
        src="../../../assets/images/integrations/toybox.png"
        alt="Toybox Systems"
        objectFit="contain"
        placeholder="none"
        width={130}
        height={150}
      />
    </BeatingHeart>
  );
}

export default Github;
